import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { mainSiteUrl } from "@/data/categories";

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="mt-20 border-t border-background-200/70 bg-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-grid-line text-lg"></i>
              </span>
              <span className="font-heading text-lg font-bold text-foreground-950 whitespace-nowrap">
                Basetao <span className="text-primary-600">Spreadsheet</span>
              </span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-600">{t("footer.disclaimer")}</p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-950">{t("footer.explore")}</h4>
            <ul className="mt-4 flex flex-col gap-2">
              <li>
                <Link to="/" className="text-sm text-foreground-600 transition hover:text-foreground-950 cursor-pointer">
                  {t("footer.home")}
                </Link>
              </li>
              <li>
                <a href="#categories" className="text-sm text-foreground-600 transition hover:text-foreground-950 cursor-pointer">
                  {t("footer.categories")}
                </a>
              </li>
              <li>
                <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 transition hover:text-foreground-950 cursor-pointer">
                  {t("footer.visitMain")}
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-950">{t("footer.resources")}</h4>
            <ul className="mt-4 flex flex-col gap-2">
              <li>
                <Link to="/article/basetao-spreadsheet-guide" className="text-sm text-foreground-600 transition hover:text-foreground-950 cursor-pointer">
                  {t("footer.guide")}
                </Link>
              </li>
              <li>
                <a href="#faq" className="text-sm text-foreground-600 transition hover:text-foreground-950 cursor-pointer">
                  {t("nav.faq")}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-background-200/70 pt-6 sm:flex-row">
          <p className="text-sm text-foreground-500">{t("footer.rights")}</p>
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 text-sm font-medium text-primary-700 transition hover:text-primary-800 cursor-pointer"
          >
            {t("footer.visitMain")}
            <i className="ri-arrow-right-up-line"></i>
          </a>
        </div>
      </div>
    </footer>
  );
}